<!-- App.svelte -->
<script>
  import { Navigate } from 'svelte-router-spa'

function getWindowHeight(){
    return 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
}

let a = getWindowHeight();

</script>

<style>

body, html {
  -moz-font-smoothing: antialiased;
  -ms-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  font-smoothing: antialiased;
  -ms-overflow-style: scrollbar;
  -webkit-text-size-adjust: 100%;
  display: block;
  position: fixed;
  background: #36765a;
  -webkit-tap-highlight-color: transparent;
}

body * { touch-action: none;  } /* scroll disable */

.is-absolute {
    position: absolute;
} 

.center {
    margin-left: auto;
    margin-right: auto;
}

.columns.is-vcentered {
  -webkit-box-align: center;
     -ms-flex-align: center;
        align-items: center;
}
</style>

<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

<body style="height: {a}px;">
<div class="container has-text-centered" style="height: 100%">
<div class="columns is-mobile" style="height: 100%">
<div class="column">

<div class="container">
    <figure class="image">
    <img class="center" src="https://storage.googleapis.com/covelab-mmti/intro/intro_1.png" style="height: {a}px; width: auto;">
    </figure>
</div>

<div class="container is-absolute is-overlay" style="margin-top: {a-a/7}px;">
<Navigate to="/intro2">
<figure class="image is-128x128 center" style="width: 150px;"><img src="/next.png"></figure>
<h1 class ="title is-6 is-overlay mt-4 mr-5 has-text-white">
<p>다음</p>
</h1>
</Navigate>
</div>

</div>
</div>
</div>
</body>
